import { useState } from "react";
import { useTranslation } from "react-i18next";
//  Functions
import { localizationMapping, deliriumValues, positionValues, mechanicalVentilationValues } from "../../../functions";
// Components
import { MainDiv, Header, Title, Body, Form, InputDataDiv, Label, AgeDiv, Input, SubmitButton } from "./styles";
import ToggleSwitch from "../../../../toggleSwitch";
import Select from "../../../../selectInput";
// Assets
import SelectArrow from "../../../../../assets/icons/ico_arrow_down.svg";

const GroupForm = ({
  isGroup1,
  isGroup2Enabled,
  setIsGroup2Enabled,
  gender,
  setGender,
  minAge,
  setMinAge,
  maxAge,
  setMaxAge,
  delirium,
  setDelirium,
  position,
  setPosition,
  mechanicalVentilation,
  setMechanicalVentilation,
  filterDataEvent,
}) => {
  const [groupColor] = useState(isGroup1 ? "#0071BC" : "#F15A24");

  const [t] = useTranslation("global");

  const isDisabled = !isGroup1 && !isGroup2Enabled;

  const renderSelect = (label, id, value, setValue, arrayValues) => {
    return (
      <InputDataDiv>
        <Label isDisabled={isDisabled}>{t(label)}</Label>
        <Select
          id={id}
          value={value}
          onChange={(e) => setValue(e.target.value)}
          padding="5px 35px 5px 10px"
          width="190px"
          arrowImg={SelectArrow}
          backgroundPosition="165px center"
          disabled={isDisabled}
        >
          <option value=""></option>
          {arrayValues.map((value) => {
            return (
              <option key={value} value={value}>
                {t(localizationMapping(value))}
              </option>
            );
          })}
        </Select>
      </InputDataDiv>
    );
  };

  return (
    <MainDiv>
      <Header background={isDisabled ? "#808080" : groupColor}>
        <Title>{`${t("group")} ${isGroup1 ? "1" : "2"}`}</Title>
        {!isGroup1 && (
          <ToggleSwitch
            isActive={isGroup2Enabled}
            setIsActive={() => setIsGroup2Enabled(!isGroup2Enabled)}
            inactiveColor="#ccc"
            activeColor="#39b54a"
          />
        )}
      </Header>
      <Body>
        <Form>
          {/* Gender */}
          <InputDataDiv>
            <Label isDisabled={isDisabled}>{t("patientGender_label")}</Label>
            <Select
              id={`gender_${groupColor}`}
              value={gender}
              onChange={(e) => setGender(e.target.value)}
              padding="5px 35px 5px 10px"
              width="190px"
              arrowImg={SelectArrow}
              backgroundPosition="165px center"
              disabled={isDisabled}
            >
              <option value=""></option>
              <option value="MALE">{t("patientGender_male")}</option>
              <option value="FEMALE">{t("patientGender_female")}</option>
            </Select>
          </InputDataDiv>
          {/* Age */}
          <InputDataDiv>
            <Label isDisabled={isDisabled}>{t("age")}</Label>
            <AgeDiv>
              <Input
                id={`minAge_${groupColor}`}
                type="number"
                placeholder="Min"
                value={minAge}
                onChange={(e) => setMinAge(e.target.value)}
                disabled={isDisabled}
              />
              <Input
                id={`maxAge_${groupColor}`}
                type="number"
                placeholder="Máx"
                value={maxAge}
                onChange={(e) => setMaxAge(e.target.value)}
                disabled={isDisabled}
              />
            </AgeDiv>
          </InputDataDiv>
          {/* Delirium */}
          {renderSelect("Delirium", `Delirium_${groupColor}`, delirium, setDelirium, deliriumValues)}
          {/* Position */}
          {renderSelect("Position", `Position_${groupColor}`, position, setPosition, positionValues)}
          {/* Mechanical ventilation */}
          {renderSelect(
            "MechanicalVentilation",
            `MV_${groupColor}`,
            mechanicalVentilation,
            setMechanicalVentilation,
            mechanicalVentilationValues
          )}
        </Form>
        <SubmitButton background={isDisabled ? "#808080" : groupColor} onClick={filterDataEvent} disabled={isDisabled}>
          {t("update")}
        </SubmitButton>
      </Body>
    </MainDiv>
  );
};

export default GroupForm;
